import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { CalloutRefresh, LanguagesForm } from "../components";
import { useUser } from "../services";
import { LoadingScreen } from "./loading";

export function LanguagesScreen() {
  // Data
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();

  // Vars
  const navigation = useNavigation();

  // Handlers
  const handleSuccess = useCallback(() => {
    alert("Profile languages updated successfully!");

    navigation.goBack();
  }, [navigation]);

  // Render
  if (isUserLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <CalloutRefresh onRefresh={refetchUser} />;
  }

  return <LanguagesForm user={user} onSuccess={handleSuccess} />;
}
